import { View, Text, Image, StyleSheet } from 'react-native'
import { LinearGradient } from 'expo-linear-gradient'
import { useTranslation } from 'react-i18next'
import { fonts } from '../../lib/theme'
import { useThemeColors } from '../../lib/useThemeColors'
import { LOGO } from '../../lib/assets'
import { tierColor, ROMAN } from '../../lib/badges'
import { darken } from '../personAvatarConfig'
import BadgeMedal from './BadgeMedal'

// Immagine da condividere di un badge (verticale, per storie e post). Disegno FISSO, uguale in tema chiaro e scuro,
// come le altre immagini di condivisione: fondo scuro con gradiente nel colore del brand.
export const BADGE_SHARE_W = 360

export default function BadgeShareCard({ family, level, leagueName }) {
  const { t, i18n } = useTranslation()
  const tc = useThemeColors()
  if (!family || !level) return null
  const color = tierColor(level.level, family.maxLevel)
  const deep = darken(tc.rosa, 0.3)
  const title = family.maxLevel > 1 ? `${t(`badges.fam.${family.category}.title`)} ${ROMAN[level.level - 1] ?? level.level}` : t(`badges.fam.${family.category}.title`)
  const date = level.awardedAt ? new Date(level.awardedAt).toLocaleDateString(i18n.language, { day: 'numeric', month: 'long', year: 'numeric' }) : ''
  const pct = level.nMembers > 0 ? Math.round((level.nEarned / level.nMembers) * 100) : 0

  return (
    <View style={{ width: BADGE_SHARE_W, height: (BADGE_SHARE_W * 16) / 9, overflow: 'hidden', backgroundColor: '#0A0A10' }}>
      <LinearGradient colors={['#0A0A10', '#14080D', deep]} start={{ x: 0.1, y: 0 }} end={{ x: 0.9, y: 1 }} style={StyleSheet.absoluteFill} />
      <View style={{ position: 'absolute', top: -90, right: -90, width: 260, height: 260, borderRadius: 130, backgroundColor: color + '22' }} />
      <View style={{ position: 'absolute', bottom: -130, left: -110, width: 320, height: 320, borderRadius: 160, backgroundColor: tc.rosa + '1A' }} />

      <View style={{ flex: 1, padding: 18 }}>
        <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
          <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
            <Image source={LOGO} style={{ width: 28, height: 28 }} resizeMode="contain" />
            <Text style={{ color: '#fff', fontSize: 12, letterSpacing: 3, fontFamily: fonts.condensedBold }}>VIRTUA CYCLING</Text>
          </View>
          {!!leagueName && <Text style={{ color: 'rgba(255,255,255,0.65)', fontSize: 10, letterSpacing: 2, fontFamily: fonts.condensed, maxWidth: 140 }} numberOfLines={1}>{leagueName.toUpperCase()}</Text>}
        </View>

        <View style={s.center}>
          <View style={[s.halo, { backgroundColor: color + '26', borderColor: color + '77' }]} />
          <BadgeMedal icon={family.icon} color={color} size={190} />
          <Text style={[s.kicker, { color }]}>{t('badges.share_label')}</Text>
          <Text style={s.title} numberOfLines={3}>{title}</Text>
          <Text style={s.desc}>{t(`badges.fam.${family.category}.desc`, { n: level.threshold })}</Text>
        </View>

        <View style={{ gap: 4, alignItems: 'center', marginBottom: 6 }}>
          {!!date && <Text style={s.meta}>{date}</Text>}
          <Text style={s.meta}>{level.nEarned > 0 ? t('badges.rarity', { pct, n: level.nEarned, m: level.nMembers }) : ''}</Text>
        </View>
      </View>
    </View>
  )
}

const s = StyleSheet.create({
  center: { flex: 1, alignItems: 'center', justifyContent: 'center', gap: 10 },
  halo: { position: 'absolute', top: '50%', marginTop: -150, width: 250, height: 250, borderRadius: 125, borderWidth: 2 },
  kicker: { fontSize: 11, letterSpacing: 5, fontFamily: fonts.condensedBold, marginTop: 16 },
  title: { color: '#fff', fontSize: 34, lineHeight: 36, textAlign: 'center', textTransform: 'uppercase', fontFamily: fonts.condensedBold },
  desc: { color: 'rgba(255,255,255,0.8)', fontSize: 15, lineHeight: 21, textAlign: 'center', maxWidth: 300 },
  meta: { color: 'rgba(255,255,255,0.7)', fontSize: 12, letterSpacing: 1, fontFamily: fonts.condensed, textAlign: 'center' },
})
